import { observable } from "mobx";

/**
 * @module:  职位管理UI相关store
 * @author Liang Huang 
 * @date 2020-08-17 15:01:48 
 */
class JobListUI {
  @observable orderListDrawer: boolean = false;
}

export default JobListUI;
